import { render, staticRenderFns } from "./RemoteUpgradeForm.vue?vue&type=template&id=01b4dc38&"
import script from "./RemoteUpgradeForm.vue?vue&type=script&lang=js&"
export * from "./RemoteUpgradeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports